import React, { useState, useEffect } from 'react';
import '../../styles/mobile/MobileEnv.css';
import { HiChevronLeft, HiWifi, HiBattery100 } from 'react-icons/hi2';
import { GoHome } from 'react-icons/go';
import { ProjectDetailContent } from '../apps/ProjectsApp';

const MobileEnvironment = ({ coreApps, extraApps, appContent, activeApp, openApp, closeApp, bg, projectDetail, closeProjectDetail }) => {
  const [time, setTime] = useState('');
  useEffect(() => {
    const update = () => setTime(new Date().toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' }));
    update();
    const int = setInterval(update, 1000);
    return () => clearInterval(int);
  }, []);

  const gridApps = [...extraApps, coreApps.find(a => a.id === 'resume')].filter(Boolean);
  const dockApps = coreApps.filter(a => a.id !== 'resume');
  const allApps = [...coreApps, ...extraApps];

  return (
    <div className="ios-mobile-env" style={{ backgroundImage: `url(${bg})` }}>
      <div className="ios-status-bar">
        <div className="ios-time">{time}</div>
        <div className="ios-status-right">
          <HiWifi size={16} />
          <HiBattery100 size={18} />
        </div>
      </div>

      <div className="ios-home-screen">
        <div className="ios-app-grid">
          {gridApps.map(app => (
            <button key={app.id} className="ios-app-btn" onClick={() => openApp(app.id)}>
              <div className="ios-icon" style={{ background: `linear-gradient(135deg, ${app.color}cc, ${app.color})` }}>
                {app.icon}
              </div>
              <span className="ios-icon-label">{app.title.replace('.app', '')}</span>
            </button>
          ))}
        </div>
      </div>

      <div className="ios-dock-wrapper">
        <div className="ios-dock">
          {dockApps.map(app => (
            <button key={app.id} className="ios-app-btn" onClick={() => openApp(app.id)}>
              <div className="ios-icon dock-icon" style={{ background: `linear-gradient(135deg, ${app.color}cc, ${app.color})` }}>
                {app.icon}
              </div>
              <span className="ios-icon-label">{app.title.replace('.app', '')}</span>
            </button>
          ))}
          <button className="ios-app-btn" onClick={() => {
            if (activeApp) {
              closeApp();
            } else if (projectDetail) {
              closeProjectDetail();
            }
          }}>
            <div className="ios-icon dock-icon" style={{ background: 'linear-gradient(135deg, #888, #444)' }}>
              <GoHome size={22} color="white" />
            </div>
            <span className="ios-icon-label">Home</span>
          </button>
        </div>
      </div>

      {/* App Fullscreen View */}
      <div className={`ios-app-fullscreen ${activeApp ? 'open' : ''}`}>
         <div className="ios-app-nav">
            <button className="ios-nav-back" onClick={closeApp}>
               <HiChevronLeft size={20} /> Home
            </button>
            <div className="ios-nav-title">
               {allApps.find(a => a.id === activeApp)?.title.replace('.app', '')}
            </div>
            <div className="ios-nav-spacer"></div>
         </div>
         <div className="ios-app-content">
            {activeApp && appContent[activeApp]}
         </div>
      </div>

      {/* Project Detail Overlay */}
      <div className={`ios-app-fullscreen ${projectDetail ? 'open' : ''}`} style={{ zIndex: 100 }}>
         <div className="ios-app-nav">
            <button className="ios-nav-back" onClick={closeProjectDetail}>
               <HiChevronLeft size={20} /> Back
            </button>
            <div className="ios-nav-title">Details</div>
            <div className="ios-nav-spacer"></div>
         </div>
         <div className="ios-app-content">
            {projectDetail && <ProjectDetailContent projectId={projectDetail} />}
         </div>
      </div>
    </div>
  );
};
export default MobileEnvironment;
